import { render, staticRenderFns } from "./freebet.vue?vue&type=template&id=23009457&"
import script from "./freebet.vue?vue&type=script&lang=js&"
export * from "./freebet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports